const { parse } = require('../../tools/smart-id')
const get = require('lodash/get')
const uniqBy = require('lodash/uniqBy')
const { translateTerritoryAlias, productAliasesByMarket } = require('./translate-territory-alias')

const validateMappedProducts = ({ marketData = [], orders, productsById, suppliers }) => {
  const mapped = []
  const notMapped = []
  const invalidMapping = []
  suppliers = uniqBy(suppliers, (supplier) => {
    const { state } = parse(supplier.id)
    return state
  })
  const productsForTranslation = productAliasesByMarket(productsById)

  suppliers.forEach(supplier => {
    const { state } = parse(supplier.id)
    const productAlias = get(marketData.find(m => m.aliases.includes(state)), 'fs_service_id')
    orders.forEach(order => {
      const { state: destinationState } = parse(order.destinationId)
      if (state !== destinationState) {
        Object.keys(order.products).forEach(productId => {
          const product = productsById[productId]
          try {
            const mappedProductId = translateTerritoryAlias(productId, productsForTranslation, productAlias)
            if (mappedProductId === productId) {
              // The market config list is in productsById.
              // If the productsById[productId] doesn't exist, that is, the product is not in the market config list
              // then, it is undefined which breaks the app down the line. To avoid notMapped being filled with undefined products,
              // we add a fall back product with just the id which is enough to identify the product and avoid breaking the app
              const fallBackProduct = {
                _id: productId
              }
              notMapped.push(product || fallBackProduct)
            } else {
              mapped.push(product)
            }
          } catch (error) {
            console.warn('cant validate mapping:', error)
            invalidMapping.push(product)
          }
        })
      }
    })
  })
  return {
    mapped,
    notMapped,
    invalidMapping
  }
}

module.exports = {
  validateMappedProducts
}
